class EndpointsConfigure {
  url = null as string | null;
  port = null as string | null;
  base = null as string | null;
  timeout = 5000;
  // AUTH Urls
  apiAuth = null as string | null;
  // IAM Urls
  apiIAM = null as string | null;
  // REDIRECT Urls
  apiRedirect = null as string | null;
  //
  verificarLoginRoute = ``;
  logoutRoute = ``;
  loginGoogle = ``;
  loginFacebook = ``;

  configureEndpoint = (baseUrl: string = 'localhost', basePort: string = '3000') => {
    const baseEndpoint = basePort ? `${baseUrl}:${basePort}` : baseUrl;

    this.url = baseUrl;
    this.port = basePort;
    this.base = baseEndpoint;
    this.apiAuth = `${baseEndpoint}/auth`;
    this.apiIAM = `${baseEndpoint}/iam`;
    this.apiRedirect = `${baseEndpoint}/redirect`;

    this.verificarLoginRoute = `${baseEndpoint}/auth`;
    this.logoutRoute = `${baseEndpoint}/auth/logout`;
    this.loginGoogle = `${baseEndpoint}/auth/google`;
    this.loginFacebook = `${baseEndpoint}/auth/facebook`;
  };
}

const Endpoints = new EndpointsConfigure();

export default Endpoints;
